module.exports = __webpack_public_path__ + "img/success.f265ccca.png";